<template>
  <div
    class="assistant-bubble !flex !h-fit !min-w-0 !flex-col !items-start !justify-between !gap-3 !rounded-br-2xl !rounded-tl-2xl !rounded-tr-2xl !bg-white !bg-opacity-60 !px-7 !py-6"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'AssistantStyleWrapper',
};
</script>
